<template>
  <div class="flex-container-item">
    <h5 v-if="title">{{ title }}</h5>
    <v-timeline width="400px" side="end" dense>
      <v-timeline-item v-for="event in events" :key="event.id" @click.native.stop="showEvent($event, event)"
        :icon="event.icon" :small="isSmall" fill-dot :color="event.color" class="cursor-pointer">
        <v-card>
          <v-card-title class="p-2 pl-4">
            <span v-if="event.lifestyleProgramCategoryColor" class="color-preview-small mr-2"  v-bind:style="{ 'background-color': event.lifestyleProgramCategoryColor }"></span>
            {{ event.name |  fixString(30, true) }}
          </v-card-title>
          <v-card-text>
            <div class="flex-container">
              <div class="inline-block">
                <h6 class="mb-1">{{ event?.start | localizedDate(facility.timeFormat) }}</h6>
                <div v-if="calendarType !== calendarTypeEnum.day" class="text-caption pr-4">{{ event?.startDate |
                  localizedDate(facility.dateFormat) }}</div>
              </div>
              <div class="inline-block pl-2">
                <strong v-if="event.location"><v-icon color="gray" class="mb-1" size="small">mdi-map-marker</v-icon> {{
                  event.location }}</strong>
                <div class="text-caption">
                  {{ event.description }}
                </div>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-timeline-item>
    </v-timeline>
    <EventPreviewCard ref="eventPreviewCard" redirectPage="calendar" @closeCalendarCard="closeCalendarCard" />
  </div>
</template>

<script>
import moment from 'moment';
import { mapState } from "vuex";
import { CalendarTypeEnum } from '@/enums/CalendarTypeEnum';
import { EventsTypes } from '@/enums/EventsTypes';
import EventPreviewCard from "@/views/calender/event-preview-card/EventPreviewCard.vue";
import { CalendarScreenTypeEnum } from '@/enums/CalendarScreenTypeEnum';

export default {
  components: { EventPreviewCard },
  props: {
    events: [],
    calendarType: {
      type: String,
      default: ''
    },
    isSmall: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      calendarTypeEnum: CalendarTypeEnum,
      isOpenCalendarCard: false,
      eventsList: [],
    };
  },
  watch: {
    events(items) {
      this.eventsList = [...items]
    },
  },

  created() {
    this.eventsList = [...this.events]
  },

  computed: {
    ...mapState({
      facility: state => state.facilityModule.selectedFacility
    }),
  },
  methods: {
    showEvent(nativeEvent, event) {
      const targetClassName = nativeEvent?.target?.className || ''
      if (targetClassName.indexOf('v-timeline-item') < 0) {
        this.isOpenCalendarCard = true;
        this.$refs.eventPreviewCard.open(nativeEvent.target, event, CalendarScreenTypeEnum.Schedule);
      }
    },
    closeCalendarCard() {
      this.isOpenCalendarCard = false
    }
  }
};
</script>

<style scoped>
.flex-container-item {
  width: 450px;
  flex-grow: 1;
}

::v-deep .v-card {
  width: 450px;
}
</style>
